<template>
  <div
    class="Polaris-Banner Polaris-Banner--withinContentContainer"
    tabindex="0"
    role="alert"
    aria-live="polite"
  >
    <div
      class="Polaris-Box"
      :style="{
        '--pc-box-color':
          type === 'critical'
            ? 'var(--p-color-text-critical)'
            : type === 'warning'
            ? 'var(--p-color-text-warning)'
            : 'var(--p-color-text-info)',
        '--pc-box-background':
          type === 'critical'
            ? 'var(--p-color-bg-surface-critical)'
            : type === 'warning'
            ? 'var(--p-color-bg-surface-warning)'
            : 'var(--p-color-bg-surface-info)',
        '--pc-box-border-radius': 'var(--p-border-radius-200)',
        '--pc-box-padding-block-start-xs': 'var(--p-space-200)',
        '--pc-box-padding-block-end-xs': 'var(--p-space-200)',
        '--pc-box-padding-inline-start-xs': 'var(--p-space-200)',
        '--pc-box-padding-inline-end-xs': 'var(--p-space-200)',
        '--pc-box-width': '100%'
      }"
    >
      <div
        class="Polaris-InlineStack"
        style="--pc-inline-stack-align: space-between; --pc-inline-stack-block-align: start; --pc-inline-stack-wrap: nowrap; --pc-inline-stack-gap-xs: var(--p-space-200); --pc-inline-stack-flex-direction-xs: row;"
      >
        <div
          class="Polaris-InlineStack"
          style="--pc-inline-stack-wrap: nowrap; --pc-inline-stack-gap-xs: var(--p-space-150); --pc-inline-stack-flex-direction-xs: row;"
        >
          <span
            :class="{
              'Polaris-Banner__text--critical': type === 'critical',
              'Polaris-Banner__text--warning': type === 'warning',
              'Polaris-Banner__text--info': type === 'info'
            }"
          >
            <span class="Polaris-Icon">
              <svg
                viewBox="1 1 18 18"
                class="Polaris-Icon__Svg"
                focusable="false"
                aria-hidden="true"
              >
                <path
                  d="M10 6.75a.75.75 0 0 1 .75.75v3.5a.75.75 0 1 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z"
                ></path>
                <path d="M11 13.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path>
                <path
                  fill-rule="evenodd"
                  d="M10 3.5c-1.045 0-1.784.702-2.152 1.447a449.26 449.26 0 0 1-2.005 3.847l-.028.052a403.426 403.426 0 0 0-2.008 3.856c-.372.752-.478 1.75.093 2.614.57.863 1.542 1.184 2.464 1.184h7.272c.922 0 1.895-.32 2.464-1.184.57-.864.465-1.862.093-2.614-.21-.424-1.113-2.147-2.004-3.847l-.032-.061a429.497 429.497 0 0 1-2.005-3.847c-.368-.745-1.107-1.447-2.152-1.447Zm-.808 2.112c.404-.816 1.212-.816 1.616 0 .202.409 1.112 2.145 2.022 3.88a418.904 418.904 0 0 1 2.018 3.875c.404.817 0 1.633-1.212 1.633h-7.272c-1.212 0-1.617-.816-1.212-1.633.202-.408 1.113-2.147 2.023-3.883a421.932 421.932 0 0 0 2.017-3.872Z"
                ></path>
              </svg>
            </span>
          </span>
          <div class="Polaris-Box" style="--pc-box-width: 100%;">
            <div
              class="Polaris-BlockStack"
              style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-200);"
            >
              <div
                class="Polaris-BlockStack"
                style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-050);"
              >
                <div>
                  <span class="Polaris-Text--root Polaris-Text--bodyMd">
                    <p>{{ text }}</p>
                    <p v-if="html" v-html="html"></p>
                  </span>
                </div>
                <div v-if="$slots.actions" class="Polaris-Banner__Actions">
                  <slot name="actions"></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String },
    type: { type: String, default: "crtical" },
    html: { type: String }
  }
};
</script>
